export function afterGet(record) {
  const newRecord = { ...record };

  return newRecord;
}
